import { create } from 'zustand';
import type { Trade, PerformanceMetrics } from '@typings/index';

interface TradeState {
    trades: Trade[];
    metrics: PerformanceMetrics | null;
    loading: boolean;
    error: string | null;

    setTrades: (trades: Trade[]) => void;
    addTrade: (trade: Trade) => void;
    updateTrade: (tradeId: string, updates: Partial<Trade>) => void;
    deleteTrade: (tradeId: string) => void;
    setMetrics: (metrics: PerformanceMetrics) => void;
    setLoading: (loading: boolean) => void;
    setError: (error: string | null) => void;
}

export const useTradeStore = create<TradeState>((set) => ({
    trades: [],
    metrics: null,
    loading: true,
    error: null,

    setTrades: (trades) => set({ trades, loading: false, error: null }),

    addTrade: (trade) => set((state) => ({
        trades: [trade, ...state.trades],
    })),

    updateTrade: (tradeId, updates) => set((state) => ({
        trades: state.trades.map((t) =>
            t.id === tradeId ? { ...t, ...updates, updatedAt: new Date() } : t
        ),
    })),

    deleteTrade: (tradeId) => set((state) => ({
        trades: state.trades.filter((t) => t.id !== tradeId),
    })),

    setMetrics: (metrics) => set({ metrics }),
    setLoading: (loading) => set({ loading }),
    setError: (error) => set({ error, loading: false }),
}));
